import { styled } from '@mui/material/styles';
import { Box, type BoxProps } from '@mui/material';
import { LazyImage } from '@/components/LazyImage';

const ImageFrame = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: '#050a0d',
  overflow: 'hidden',
  flexShrink: 0,

  boxShadow: `
    inset 0 0 12px rgba(0,0,0,0.8),
    0 0 10px rgba(125,211,199,0.15)
  `,

  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    filter: `
      grayscale(0.5)
      contrast(1.1)
      brightness(0.8)
    `,
  },
}));

export const TerminalImage = ({
  src,
  alt,
  ...props
}: BoxProps &
  Pick<React.ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'>) => {
  return (
    <ImageFrame {...props}>
      <LazyImage src={src} alt={alt} />
    </ImageFrame>
  );
};
